var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ddoCartArea',{attrs:{"cart":_vm.cart,"callbacks":_vm.callbacks,"cart-sub-total":_vm.cartSubTotal,"tax":_vm.tax,"cart-total":_vm.cartTotal,"checkout-bool":_vm.checkoutBool,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }